import { useState } from "react";
import { useParams } from "react-router-dom";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import { FaCirclePlus } from "react-icons/fa6";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { useDeleteStateCodeAliasByIdServiceMutation, useSearchAllStateCodeAliasQuery } from "../stateCodeAliasApi";
import ModalButton from "../../../../components/common/form/ModalButton";
import StateCodeAliasFieldForm from "./modal/StateCodeAliasFieldForm";
import { FaTrash } from "react-icons/fa";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";

const AliasDetailInfo = () => {
    const iconButtonStyle = "cursor-pointer  text-lg  hover:text-highlight-7 text-highlight-0";

    const { codeId } = useParams();
    const [deleteStateCodes, { isLoading }] = useDeleteStateCodeAliasByIdServiceMutation();
    const [aliasId, setAliasId] = useState("");
    const [showAliasUpdate, setShowAliasUpdateUpdate] = useState(false);

    const handleDelete = async (codeId: string) => {
        if (codeId) {
            await deleteStateCodes(codeId).unwrap();
        }
    };

    const columns: DataTableColumn[] = [
        {
            label: "Alias", accessor: "alias", visibility: { hasShowSetting: false },
            cell: (props: any) => {
                return <span className={"active cursor column-link cursor-pointer text-highlight-0"} onClick={(e) => {
                    setShowAliasUpdateUpdate(true);
                    setAliasId(props.row.original.id);
                }}>{props.value}</span>;
            }
        },
        {
            label: "Source",
            accessor: "stateCodeSource",
            visibility: { hasShowSetting: false },
            cell: (props: any) => props.value ?? "--",
        },
        {
            label: "State",
            accessor: "stateName",
            visibility: { hasShowSetting: false },
            cell: (props: any) => props.value ?? "--",
        },
        {
            label: "County",
            accessor: "countyId",
            visibility: { hasShowSetting: false },
            cell: (props: any) => props.value ?? "--",
        },

        {
            label: "Action", accessor: " ",
            canSort: false,
            cell: (props: any) => {
                return <>
                    <div className="ml-3">
                        <ModalButton
                            triggerButton={<FaTrash className={iconButtonStyle}
                                title={"Delete Alias"} />}
                            modal={
                                <ConfirmationModal
                                    show={true}
                                    setShow={() => {
                                    }}
                                    title={"Delete Alias"}
                                    bodyMessage={"Are you sure you want to delete this Alias?"}
                                    onSubmit={() => handleDelete(props.row.original.id)}
                                    isLoading={isLoading}
                                />
                            }
                        />
                    </div>
                </>
            }
        }
    ]

    return (
        <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm mb-3 rounded-md">
            <div className="flex justify-between items-center border-b border-[rgba(0,0,0,0.1)] p-2">
                <h5 className="font-semibold text-surface-0">Alias</h5>
                {hasPermission(["STATCODE-U"]) &&
                    <ModalButton
                        triggerButton={<FaCirclePlus className={iconButtonStyle}
                            title={"Add Alias Form"} />}
                        modal={
                            <StateCodeAliasFieldForm
                                show={true}
                                setShow={() => {
                                }}
                               
                            />
                        }
                    />}

            </div>
            <div className="p-2">
                <DataTable
                    columns={columns}
                    actions={{
                        fetchAction: useSearchAllStateCodeAliasQuery,
                    }}
                    defaultSortOptions={{
                        accessor: "creationDate",
                        direction: "asc",
                    }}
                    defaultFilter={{
                        stateCodeId: codeId
                    }}
                    renderOptions={{ skipUserSettingRender: true }}
                    basePermission={"STATCODE"}
                    appendFilterToUrl={false}
                />
            </div>

            {showAliasUpdate && (
                <StateCodeAliasFieldForm
                    show={true}
                    aliasId={aliasId}
                    setShow={setShowAliasUpdateUpdate}
                    isReadOnly={!hasPermission(["STATCODE-U"])}
                />
            )}
        </div>
    );
}

export default AliasDetailInfo;